import './ButtonCyan.scss';